module.exports = "https://static.wmbcdn.com/uniweb/images/621484abb9301cc1d0e371f07d80285d.svg";